export default __webpack_public_path__ + "static/media/Blessed Signet.b57d10fe.jpg";